module.exports = __webpack_public_path__ + "img/ico_10.f524f57d.png";